export default {"src":"/_next/static/media/google.c83c36a9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};